import React from 'react';
import ContentLoader from 'react-content-loader';
import * as Styled from './ContentPlaceholder.styles';

var ContentPlaceholder = function ContentPlaceholder() {
  return /*#__PURE__*/React.createElement(Styled.ContentPlaceHolderContainer, null, /*#__PURE__*/React.createElement(ContentLoader, {
    viewBox: "0 0 400 160",
    speed: 1,
    backgroundColor: "#f0f0f0",
    foregroundColor: "#e5e5e5",
    preserveAspectRatio: "xMinYMid slice",
    uniqueKey: "as-cc-contentPlaceholder"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "16",
    r: "7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "35",
    y: "11",
    rx: "2",
    ry: "2",
    width: "100",
    height: "10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "33",
    width: "400",
    height: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "15",
    y: "45",
    rx: "2",
    ry: "2",
    width: "150",
    height: "14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "15",
    y: "65",
    rx: "2",
    ry: "2",
    width: "125",
    height: "9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "15",
    y: "90",
    rx: "2",
    ry: "2",
    width: "75",
    height: "10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "15",
    y: "135",
    rx: "2",
    ry: "2",
    width: "50",
    height: "10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "360",
    y: "90",
    rx: "2",
    ry: "2",
    width: "30",
    height: "10"
  }), /*#__PURE__*/React.createElement(Styled.StoreDistanceATTContentPlaceholder, {
    x: "300",
    y: "130",
    rx: "2",
    ry: "2",
    width: "90",
    height: "20"
  })));
};

export default ContentPlaceholder;